export default "__VITE_ASSET__COQRM$dm__"